import { IPagedFilters } from '~/services/api/types';

export interface IPagination {
  page: number;
  itemsPerPage: number;
  hasMore: boolean;
}

export const getPaginationPayload = ({ page, itemsPerPage }: IPagination): IPagedFilters => {
  if (page === null || itemsPerPage === null) {
    return {};
  }

  const start = page * itemsPerPage;
  const end = start + itemsPerPage;

  return {
    start,
    end,
  };
};

export const mergeUniqueBy = <T, K>(
  existing: T[],
  incoming: T[],
  keySelector: (item: T) => K,
): T[] => {
  const existingKeys = new Set(existing.map(keySelector));

  const uniqueIncoming = incoming.filter(item => !existingKeys.has(keySelector(item)));

  return [...existing, ...uniqueIncoming];
};

export default {};
